import bicepsPNG from '~/assets/images/anatomy/biceps.png'
import bicepsWEBP from '~/assets/images/anatomy/biceps.webp'
import glutesPNG from '~/assets/images/anatomy/glutes.png'
import glutesWEBP from '~/assets/images/anatomy/glutes.webp'
import heartPNG from '~/assets/images/anatomy/heart.png'
import heartWEBP from '~/assets/images/anatomy/heart.webp'
import masseterPNG from '~/assets/images/anatomy/masseter.png'
import masseterWEBP from '~/assets/images/anatomy/masseter.webp'
import GridChoice from '~/pages/anatomy/libs/components/GridChoice'
import { TPageProps } from '~/shared/types/commonTypes'

const OPTIONS = [
  {
    key: 'heart',
    i18nKey: 'onboarding.strongestMuscle.options.heart',
    png: heartPNG,
    webp: heartWEBP,
  },
  {
    key: 'glutes',
    i18nKey: 'onboarding.strongestMuscle.options.glutes',
    png: glutesPNG,
    webp: glutesWEBP,
  },
  {
    key: 'masseter',
    i18nKey: 'onboarding.strongestMuscle.options.masseter',
    png: masseterPNG,
    webp: masseterWEBP,
  },
  {
    key: 'biceps',
    i18nKey: 'onboarding.strongestMuscle.options.biceps',
    png: bicepsPNG,
    webp: bicepsWEBP,
  },
]

const StrongestMuscle = (props: TPageProps) => (
  <GridChoice
    {...props}
    options={OPTIONS}
    questionKey="onboarding.strongestMuscle.question"
    question="What is the strongest muscle in the human body based on its weight?"
    answersAtBottom
  />
)

export default StrongestMuscle
